import React, { useRef } from "react";
import { useEffect, useState, useMemo } from "react";
import Icons from "../../../global/constants/icons.ts";
import {
  TextField,
  Box,
  FormControl,
  InputAdornment,
  Autocomplete,
  Popover,
  IconButton,
  Dialog,
  Typography,
  Button,
} from "@mui/material";
import {
  ApiGetAllocations,
  ApiGetVenueList,
  ApiGetClientEntityByClientGroupId,
  ApiGetShopperPopUpDetails,
  ApiEditorClientEntities,
  ApiEditorVenueList,
  ApiGetAdminMonthlyAllocations,
  ApiPutShopperDetails,
} from "../../../apiService/Core/Apicall.tsx";
import { useSelector } from "react-redux";
import type { RootState } from "../../../global/config/store.ts";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { toast } from "react-toastify";
import Dcrage from "../OrphanAllocation/Dcrage.tsx";
import { useNavigate } from "react-router-dom";
import new_orange from '../../../assets/images/new_orange.png'
import new_green from '../../../assets/images/new_green.png'
import { CancelOutlined, Note, PersonOutlined } from '@mui/icons-material';
import { Edit } from "lucide-react";



function useDebounce<T>(value: T, delay: number): T {
  const [debouncedValue, setDebouncedValue] = useState<T>(value);
  useEffect(() => {
    const timer = setTimeout(() => {
      setDebouncedValue(value);
    }, delay);
    return () => clearTimeout(timer);
  }, [value, delay]);
  return debouncedValue;
}

const MonthlyCalendar: React.FC = () => {
  const [search, setSearch] = useState("");
  const [clientEntityList, setClientEntityList] = useState<any>([]);
  const [clientEntityId, setClientEntityId] = useState<string | null>(null);
  const [venueName, setVenueName] = useState([]);
  const [venueNameValue, setVenueNameValue] = useState<any>(null);
  const [allocations, setAllocations] = useState([]);
  const [selectedDate, setSelectedDate] = useState<Date>(new Date());
  const Clientlist = useSelector((state: RootState) => state.client.clientList);
  const [selectedClient, setSelectedClient] = useState<any>(null);
  const [ClientId, setClientId] = useState(null);
  const [anchorEl, setAnchorEl] = useState(null);
  const [selectedIndex, setSelectedIndex] = useState(null);
  const [loanData, setLoanData] = useState();
  const [showNotes, setshowNotes] = useState<boolean>(false);
  const [selectedShopper, setSelectedShopper] = useState('');
  const [selectedNotes, setselectedNotes] = useState<number>();
  const navigate = useNavigate()
  const [fullText, setFullText] = useState('');
  const [fullText2, setFullText2] = useState('');
  const [staticLineInserted, setStaticLineInserted] = useState(false);
  const [staticLineInserted2, setStaticLineInserted2] = useState(false);
  const shoppernoteRef = useRef<HTMLTextAreaElement | null>(null);
  const trainingnoteRef = useRef<HTMLTextAreaElement | null>(null);
  const userRole: any = localStorage.getItem("userRole");
  const userId: any = localStorage.getItem("userId");
  useEffect(() => {
    if (Clientlist.length > 2) {
      setSelectedClient(Clientlist[2]);
      setClientId(Clientlist[2].clientGroupName);
    }
  }, [Clientlist]);

  const debouncedClientEntityId = useDebounce(clientEntityId, 500);
  const debouncedVenue = useDebounce(venueNameValue, 700);

  const monthDays = useMemo(() => {
    const year = selectedDate.getFullYear();
    const month = selectedDate.getMonth();
    const daysInMonth = new Date(year, month + 1, 0).getDate();
    return Array.from({ length: daysInMonth }, (_, i) => {
      const date = new Date(year, month, i + 1);
      return {
        fullDate: date.toLocaleDateString("en-US", {
          month: "short",
          day: "numeric",
        }),
        weekday: date.toLocaleDateString("en-US", { weekday: "long" }),
        isoDate: date.toISOString(),
        dayOfMonth: i + 1,
      };
    });
  }, [selectedDate]);

  useEffect(() => {
    // Only fetch client list on initial load
    handleGetClientList();
    // We'll handle allocation fetching in a separate effect
  }, []);

  // Add a new useEffect that will run when selectedClient is set initially
  useEffect(() => {
    if (selectedClient) {
      handleGetAllocation();
    }
  }, [selectedClient]);

  useEffect(() => {
    if (debouncedClientEntityId) {
      ApiCallGetVenueList(debouncedClientEntityId);
    } else {
      setVenueName([]);
      setVenueNameValue(null);
    }
  }, [debouncedClientEntityId]);

  useEffect(() => {
    if (clientEntityId === null) {
      setVenueName([]);
    }
  }, [clientEntityId]);

  useEffect(() => {
    handleGetClientList();
  }, [ClientId]);

  useEffect(() => {
    if (selectedClient) {
      // Only call if selectedClient exists
      handleGetAllocation();
    }
  }, [debouncedVenue, selectedDate]);

  const handleHover = async (event, index, item?: any) => {
    setAnchorEl(event.currentTarget);
    // Store the hovered row index
    try {
      const currentDate = new Date();
      const currentMonth = currentDate.getMonth() + 1; // Months are zero-based, so add 1
      const currentYear = currentDate.getFullYear();

      const data = `?userId=${item?.appliedData?.userId}&currentMonth=${currentMonth}&currentYear=${currentYear}`;

      // Call API to get shopper details
      const response = await ApiGetShopperPopUpDetails(data);

      if (!response.status) {
        toast.error("Failed to load shopper details");
        return;
      }

      // Set shopper details from API response
      setLoanData(response.data);
      setSelectedIndex(index);
    } catch (error) {
      //toast.error("Error loading shopper details");
    }
  };

  const handleClose = () => {
    setAnchorEl(null);
    setSelectedIndex(null);
  };

  const handleGetAllocation = async () => {
    const jobMonth = selectedDate.getMonth() + 1; // +1 because getMonth() returns 0-11
    const jobYear = selectedDate.getFullYear();

    let data = `?offset=0&limit=100&jobMonth=${jobMonth}&jobYear=${jobYear}`;
    if (venueNameValue) data += `&venueId=${venueNameValue}`;
    if (selectedClient?.clientGroupName)
      data += `&allocationClientGroup=${selectedClient.clientGroupName}`;

    try {
      const res: any = await ApiGetAdminMonthlyAllocations(data);
      setAllocations(res.data);
    } catch (error) {
      console.error("Error during API call:", error);
    }
  };


  const handleGetClientList = async () => {
    if (!ClientId) return;
    const data = `?ClientGroupName=${ClientId}`;
    const data2 = `?editorId=${userId}&ClientGroupName=${ClientId}`;

    try {
      const res: any = userRole == 3 ? await ApiEditorClientEntities(data2) : await ApiGetClientEntityByClientGroupId(data);
      setClientEntityList(res.data);
    } catch (error) {
      console.error("Error during API call:", error);
    }
  };

  const ApiCallGetVenueList = async (debouncedClientEntityId: string) => {
    const data = `?clientEntityId=${clientEntityId}&offset=0&limit=500`;
    const data2 = `?clientEntityId=${clientEntityId}&editorId=${userId}`;
    try {
      const res = userRole == 3 ? await ApiEditorVenueList(data2) : await ApiGetVenueList(data);
      const response = res?.data.map((item) => ({
        label: item.venueName,
        value: item.venueId,
      }));
      setVenueName(response);
    } catch (error) {
      console.error("Error fetching venue list:", error);
    }
  };

  const handleOnFocus = (e) => {

    if (!staticLineInserted) {
      e.preventDefault(); // prevent newline from default action
      const now = new Date();
      const formatted = now.toLocaleString(); // e.g., 7/14/2025, 12:35:10 PM
      const updatedText = `${fullText.length > 1 ?`${fullText}\n`: ""}${selectedShopper}-${formatted}:\n`; // add static line
      setFullText(updatedText);
      setStaticLineInserted(true);

      setTimeout(() => {
        const textarea = shoppernoteRef && shoppernoteRef.current;
        if (textarea) {
          textarea.focus(); // ensure focus
          textarea.setSelectionRange(updatedText.length, updatedText.length);
        }
      }, 0);

    }
  };
  const handleOnFocus2 = (e) => {

    if (!staticLineInserted2) {
      e.preventDefault(); // prevent newline from default action
      const now = new Date();
      const formatted = now.toLocaleString(); // e.g., 7/14/2025, 12:35:10 PM
      const updatedText = `${fullText2.length > 1 ?`${fullText2}\n`: ""}${selectedShopper}-${formatted}:\n`; // add static line
      setFullText2(updatedText);
      setStaticLineInserted2(true);

      setTimeout(() => {
        const textarea = trainingnoteRef && trainingnoteRef.current;
        if (textarea) {
          textarea.focus(); // ensure focus
          textarea.setSelectionRange(updatedText.length, updatedText.length);
        }
      }, 0);

    }
  };

  

  const handleChange = (e) => {
    setFullText(e.target.value);
  };
  const handleOpenNotes = (allocation) => {
    allocation?.shopperNotes !== null ? setFullText(allocation?.shopperNotes) : setFullText('');
    allocation?.trainingNotes !== null ? setFullText2(allocation?.trainingNotes) : setFullText2('');
    setStaticLineInserted(false);
    setStaticLineInserted2(false);
    setSelectedShopper(allocation.shopperName)
    setshowNotes(true);
    setselectedNotes(allocation.allocationId)
  }

  const handleChangetraining = (e) => {
    setFullText2(e.target.value);
  };

  const handleEditScoreCard = (allocationId: any) => {
    navigate(`/createOrEditScoreCard/${allocationId}`, {
      state: { clientGroup: ClientId },
    });
  }
  const saveNotes = async (userId: any) => {
    try {
      const data = {
        userId: userId,
        shopperNotes: fullText,
        trainingNotes: fullText2,
      };
      const response = await ApiPutShopperDetails(data);

      toast.success("Shopper notes saved successfully");
      setshowNotes(false)
      await handleGetAllocation()
      setFullText('')
      setFullText2('')
    } catch (error) {
      console.error("Error saving shopper notes:", error);
      toast.error("Error saving shopper notes");
    }
  };


  return (
    <div style={{ backgroundColor: "white", padding: "16px" }}>
      {/* Status Legend */}
      <div
        style={{
          display: "flex",
          justifyContent: "space-between", // push items to edges
          alignItems: "center",
          gap: "8px",
          marginBottom: "16px",
        }}
      >
        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: "8px",
            flexWrap: "wrap",
          }}
        >
          <span style={{ fontWeight: 500 }}>Code :</span>
          {[
            { label: "Approved - Metro", color: "mediumslateblue" },
            { label: "Approved - Regional", color: "pink" },
            { label: "Approved (SAFETY)", color: "#F9C74F" },
            { label: "CheckedIn", color: "yellow" },
            { label: "Checkout", color: "green" },
            { label: "Report Submitted", color: "skyblue" },
            { label: "Report Approved", color: "gray" },
          ].map((item, idx) => (
            <div
              key={idx}
              style={{
                backgroundColor: item.color,
                color: ["yellow", "pink", "hotpink", "skyblue"].includes(
                  item.color
                )
                  ? "#000"
                  : "#fff",
                padding: "4px 8px",
                borderRadius: "4px",
                fontSize: "12px",
                fontWeight: 500,
              }}
            >
              {item.label}
            </div>
          ))}
        </div>

        <div>
          <LocalizationProvider dateAdapter={AdapterDateFns}>
            <DatePicker
              views={["year", "month"]}
              openTo="month"
              label="Select Month"
              value={selectedDate}
              onChange={(newValue) => newValue && setSelectedDate(newValue)}
              sx={{ width: 250 }}
            />
          </LocalizationProvider>
        </div>
      </div>

      <div
        style={{ display: "flex", justifyContent: "center", margin: "24px 0" }}
      >
        {/* <LocalizationProvider dateAdapter={AdapterDateFns}>
          <DatePicker
            views={["year", "month"]}
            label="Select Month"
            value={selectedDate}
            onChange={(newValue) => newValue && setSelectedDate(newValue)}
            sx={{ width: 250 }}
          />
        </LocalizationProvider> */}
      </div>

      <div className="scheduleContainer">
        <div className="scheduleRight-slide">
          <div className="card-container">
            <div
              style={{
                display: "flex",
                gap: "16px",
                width: "100%",
                justifyContent: "space-between",
              }}
            >
              <div style={{ width: "50%" }}>
                <TextField
                  variant="outlined"
                  placeholder="Search here..."
                  value={search}
                  onChange={(e) => setSearch(e.target.value)}
                  sx={{
                    borderRadius: "10px",
                    "& fieldset": {
                      borderRadius: "10px",
                    },
                  }}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <img src={Icons.searchNormal || "/placeholder.svg"} />
                      </InputAdornment>
                    ),
                  }}
                />
              </div>
              <div style={{ display: "flex", gap: "16px", width: "100%" }}>
                <FormControl fullWidth>
                  <Autocomplete
                    options={Clientlist}
                    value={selectedClient}
                    getOptionLabel={(option: any) =>
                      option?.clientGroupName || ""
                    }
                    isOptionEqualToValue={(option, value) =>
                      option?.clientGroupDBName === value?.clientGroupDBName
                    }
                    onChange={(event, newValue) => {
                      setSelectedClient(newValue);
                      setClientId(newValue?.clientGroupName || null);

                      if (
                        !newValue ||
                        (selectedClient &&
                          newValue.clientGroupName !==
                          selectedClient.clientGroupName)
                      ) {
                        setClientEntityId(null);
                        setVenueNameValue(null);
                        setClientEntityList([]);
                      }
                    }}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label="Select Client"
                        variant="outlined"
                        InputLabelProps={{
                          sx: { color: "text.primary" },
                        }}
                        InputProps={{
                          ...params.InputProps,
                          endAdornment: <>{params.InputProps.endAdornment}</>,
                        }}
                      />
                    )}
                  />
                </FormControl>

                <FormControl fullWidth>
                  <Autocomplete
                    disablePortal
                    options={clientEntityList.filter(
                      (item) => item.clientEntityId !== null
                    )}
                    getOptionLabel={(option) => option?.entityName || ""}
                    onChange={(event, newValue: any) => {
                      setClientEntityId(newValue?.clientEntityId || null);
                      if (!newValue) setVenueNameValue(null);
                    }}
                    value={
                      clientEntityList.find(
                        (option) => option?.clientEntityId === clientEntityId
                      ) || null
                    }
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label="Select Business"
                        InputLabelProps={{
                          sx: { opacity: 1, color: "text.primary" },
                        }}
                      />
                    )}
                  />
                </FormControl>

                <FormControl fullWidth>
                  <Autocomplete
                    disablePortal
                    options={venueName}
                    value={
                      venueName.find(
                        (option: any) => option.value === venueNameValue
                      ) || null
                    }
                    onChange={(event, newValue: any) =>
                      setVenueNameValue(newValue?.value)
                    }
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label="Select Venue"
                        InputLabelProps={{
                          sx: { opacity: 1, color: "text.primary" },
                        }}
                      />
                    )}
                  />
                </FormControl>
              </div>
            </div>
          </div>
        </div>
      </div>

      {monthDays.map(({ fullDate, weekday, dayOfMonth }, index) => {
        const filteredAllocations = allocations.filter((allocation: any) => {
          const eventDate = new Date(
            allocation?.selectedVisitDate
          );
          const eventDay = eventDate.getDate();
          const eventMonth = eventDate.getMonth();
          const eventYear = eventDate.getFullYear();
          const matchesDate =
            eventDay === dayOfMonth &&
            eventMonth === selectedDate.getMonth() &&
            eventYear === selectedDate.getFullYear();
          const matchesVenueId = venueNameValue
            ? allocation?.venueId?.venueId === venueNameValue
            : true;
          const matchesSearch = search
            ? allocation?.venueName
              ?.toLowerCase()
              .includes(search.toLowerCase())
            : true;
          return matchesDate && matchesSearch;
        });

        // const filteredAllocations = allocations.filter((allocation: any) => {
        //   //const statusCode = allocation?.allocationStatusId?.statusCode;
        //   //if (statusCode === "created" || statusCode === "shopper_applied") return false;

        //   const dateString = allocation?.appliedData?.selectedVisitDate;
        //   if (!dateString) return false;

        //   const eventDate = new Date(dateString);
        //   if (isNaN(eventDate.getTime())) {
        //     console.warn("Invalid date:", dateString, allocation);
        //     return false;
        //   }

        //   const eventDay = eventDate.getDate();
        //   const eventMonth = eventDate.getMonth();
        //   const eventYear = eventDate.getFullYear();

        //   const matchesDate =
        //     eventDay === dayOfMonth &&
        //     eventMonth === selectedDate.getMonth() &&
        //     eventYear === selectedDate.getFullYear();

        //   const matchesVenueId = venueNameValue
        //     ? allocation?.venueId?.venueId === venueNameValue
        //     : true;

        //   const matchesSearch = search
        //     ? allocation?.venueId?.venueName
        //         ?.toLowerCase()
        //         .includes(search.toLowerCase())
        //     : true;

        //   return matchesDate && matchesVenueId && matchesSearch;
        // });

        if (filteredAllocations.length === 0) return null;

        return (
          <div key={index} className="scheduleContainer">
            <div className="scheduleLeft-slide">
              {fullDate}
              <br />
              {weekday}
            </div>
            <div className="scheduleRight-slide">
              <div className="card-container">
                {filteredAllocations.map((allocation: any, i) => {
                  // setFullText(allocation?.shopperNotes)
                  // Determine card color based on reportStatus, checkInDateTime, and checkOutDateTime
                  let cardColor = "#FFF1B3"; // Default color
                  let fontColor = "#fff";
                  if (allocation.locationType === "city") {
                    cardColor = "mediumslateblue";
                  } else if (allocation.locationType === "region") {
                    cardColor = "pink";
                  }

                  if (
                    allocation.checkInDateTime &&
                    !allocation.checkOutDateTime
                  ) {
                    cardColor = "yellow"; // CheckedIn
                    fontColor = "#000";
                  } else if (
                    allocation.checkInDateTime &&
                    allocation.checkOutDateTime
                  ) {
                    cardColor = "green"; // Checkout
                  }

                  // Check reportStatus
                  if (allocation.reportStatus) {
                    if (allocation.reportStatus === "con") {
                      cardColor = "skyblue"; // Report Submitted
                    } else if (allocation.reportStatus === "app") {
                      cardColor = "gray"; // Report Approved
                    }
                  }

                  return (
                    <div
                      key={i}
                      className="event-card"
                      style={{
                        position: 'relative',
                        backgroundColor: cardColor,
                        border: "1px solid #CDCDCD",
                      }}
                    >
                      <div className="event-info">
                        <div>
                          <div onClick={() => { navigate(`/admin/allocation-details/${allocation?.allocationId}`) }}>
                            <div className="d-flex align-items-center mt-1 mb-2" style={{ gap: '10px' }}>
                              <img
                                src={allocation?.venulogo || Icons.GlenMark}
                                alt="Company Logo"
                                className="company-logo"
                                style={{
                                  borderRadius: "10px",
                                  height: "30px",
                                  width: "35px",
                                }}
                              />
                              <p
                                className="company-name"
                                style={{ color: fontColor }}
                              >
                                {allocation?.venueName}{" "}
                                {/* <span
                              className="product-name"
                              style={{ color: fontColor, cursor: "pointer" }}
                              onMouseEnter={(e) => {
                                //setLoanData(item);
                                // handleHover(e, i, allocation);

                              }}
                            >
                              | {allocation?.shopperName}
                            </span> */}
                              </p>
                            </div>
                            <p className="d-flex my-1 align-items-center" style={{ gap: '5px' }}>
                              {allocation?.shopTypeName && <span className="border px-2 " style={{ borderRadius: '5px', fontSize: '12px', color: fontColor }}>{allocation?.shopTypeName}</span>}
                              {allocation?.venueCode && <span className="border px-2 " style={{ borderRadius: '5px', fontSize: '12px', color: fontColor }}>{allocation?.venueCode}</span>}
                              {allocation?.venueGroup && <span className="border px-2 " style={{ borderRadius: '5px', fontSize: '12px', color: fontColor }}>{allocation?.venueGroup}</span>}
                            </p>
                            <p className="mb-2" style={{ color: fontColor, fontSize: '14px' }}><strong>Editor:</strong> {allocation?.editors}</p>
                            <p className="mb-2" style={{ color: fontColor, fontSize: '14px' }}><strong>Time:</strong> {allocation?.visitTimeInformation}</p>
                          </div>
                          <div className="d-flex align-item-center justify-content-between" style={{ gap: "30px" }}>
                            <div className="d-flex align-items-center" style={{ gap: '5px' }}>
                              <PersonOutlined sx={{ color: fontColor }} />
                              <p
                                className="event-time"
                                style={{ color: fontColor }}
                              >
                                {
                                  allocation?.shopperName
                                }
                              </p>
                              {Number(allocation.totalReportCountOfShopper) < 2 &&
                                (<img
                                  height='20px'
                                  src={Number(allocation.totalReportCountOfShopper) === 1 ? new_green : new_green}
                                />)}
                            </div>
                            <div className="d-flex align-items-center" style={{ gap: '2px' }}>
                              <IconButton className="m-0 p-0">
                                <Note onClick={() => { handleOpenNotes(allocation); }} sx={{ color: 'lime' }} height='20px' />
                              </IconButton>
                              <IconButton className="m-0 p-0" onClick={() => { handleEditScoreCard(allocation.allocationId) }}
                              >
                                <Edit color={fontColor} height='20px' />
                              </IconButton>

                            </div>

                          </div>
                        </div>
                      </div>

                      {showNotes && selectedNotes == allocation.allocationId &&
                        <Box
                          boxShadow='1px 1px 5px black'
                          bgcolor='white'
                          borderRadius='10px'
                          className='p-1'
                          minHeight='500px'
                          position='absolute'
                          left='90%'
                          zIndex={99}
                          top='10%'
                          minWidth='500px'
                        >

                          <Box className='mt-0 pt-0'>
                            <Box className='d-flex justify-content-end m-0 p-0'>
                              <IconButton onClick={() => { setshowNotes(false); setselectedNotes(0) }}><CancelOutlined /></IconButton>
                            </Box>
                            <Box className='mb-2'>
                              <Typography variant="h6" fontWeight='bold' bgcolor='#75724C' className="py-1 text-center text-light">Shopper Notes</Typography>
                              <Box className='p-1'>
                                <textarea
                                  className="border-0"
                                  value={fullText}
                                  ref={shoppernoteRef}
                                  onFocus={handleOnFocus}
                                  onChange={handleChange}

                                  rows={8}
                                  style={{
                                    width: '100%',
                                    boxShadow: '1px 1px 3px black',
                                    fontSize: '14px',
                                    padding: '8px',
                                  }}
                                />
                              </Box>
                            </Box>
                            <Box>
                              <Typography variant="h6" fontWeight='bold' bgcolor='#75724C' className="py-1 text-center text-light">Training Notes</Typography>
                              <Box className='p-1'>
                                <textarea
                                  className="border-0"
                                  ref={trainingnoteRef}
                                  value={fullText2}
                                  onFocus={handleOnFocus2}
                                  onChange={handleChangetraining}

                                  rows={8}
                                  style={{
                                    width: '100%',
                                    boxShadow: '1px 1px 3px black',
                                    fontSize: '14px',
                                    padding: '8px',
                                  }}
                                />
                              </Box>
                            </Box>
                            <Box className='d-flex justify-content-center my-3'>
                              <Button className="py-1 px-4" onClick={() => { saveNotes(allocation?.userId) }} sx={{ backgroundColor: '#75724C', color: 'white' }}>Save</Button>
                            </Box>
                          </Box>
                        </Box>}
                    </div>
                  );
                })}
                <Popover
                  open={Boolean(anchorEl) && selectedIndex === index}
                  anchorEl={anchorEl}
                  onClose={handleClose}
                  anchorOrigin={{
                    vertical: "bottom",
                    horizontal: "center",
                  }}
                  transformOrigin={{
                    vertical: "top",
                    horizontal: "center",
                  }}
                >
                  <Dcrage handleClose={handleClose} loanData={loanData} />
                </Popover>

              </div>
            </div>
          </div>
        );
      })}

      {allocations.length === 0 && (
        <p style={{ textAlign: "center", padding: "2rem" }}>
          No events found for selected filters.
        </p>
      )}
    </div>
  );
};

export default MonthlyCalendar;
